import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: UpdateChannelInput!) {
    updateChannel (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Channels/UpdateMutation.js